import { ColorEnum } from '@/constants/color'
import Pill from '@/features/ui/components/Pill'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

interface HeaderProps {
    name: string
    selectionRule?: string
    required?: boolean
}

const Header: FC<HeaderProps> = ({ name, selectionRule, required = false }) => {
    const { t } = useTranslation()

    return (
        <View style={styles.container}>
            <View style={styles.nameAndSelectionRuleContainer}>
                <Typography.Heading variant="h4" numberOfLines={1}>
                    {name}
                </Typography.Heading>
                {selectionRule && (
                    <Typography.Description
                        font="medium"
                        size="small"
                        numberOfLines={1}
                        style={styles.selectionRuleText}
                    >
                        {selectionRule}
                    </Typography.Description>
                )}
            </View>
            {required && <Pill color="destructive">{t('form.requiredFieldLabel')}</Pill>}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        maxWidth: '100%',
        gap: 8,
    },
    nameAndSelectionRuleContainer: {
        flexShrink: 1,
        gap: 4,
    },
    selectionRuleText: {
        color: ColorEnum.JET_500,
    },
})

export default Header
